module.exports = __webpack_public_path__ + "img/reservasi.1da77173.jpg";